<template>
  <div
    class="listen min-h-screen flex items-center justify-center p-4 bg-base-200"
  >
    <div class="container mx-auto max-w-screen-md">
      <div class="card bg-base-100 shadow-xl">
        <div class="card-body items-center text-center">
          <h2 class="card-title text-4xl font-bold mb-4">Listen</h2>
          <iframe
            class="spotify-iframe rounded-lg w-full"
            src="https://open.spotify.com/embed/artist/3xrbKno8shx3H22Xz8omC8"
            height="380"
            frameborder="0"
            allowtransparency="true"
            allow="encrypted-media"
          ></iframe>
          <div class="divider mt-6 mb-4">OR</div>
          <p class="mb-4">Listen on your favorite service:</p>
          <div class="flex justify-center space-x-4">
            <a
              href="https://open.spotify.com/artist/3xrbKno8shx3H22Xz8omC8?si=-ErxmcGVSQiUQrkaQ_ttbg"
              target="_blank"
              rel="noopener"
              class="btn btn-circle btn-lg"
            >
              <i class="fab fa-spotify text-2xl"></i>
            </a>
            <a
              href="https://music.apple.com/us/artist/sqwerv/1564277335"
              target="_blank"
              rel="noopener"
              class="btn btn-circle btn-lg"
            >
              <i class="fab fa-apple text-2xl"></i>
            </a>
            <a
              href="https://www.youtube.com/channel/UCtbI8FWG4a1As9wx1E4pYyQ"
              target="_blank"
              rel="noopener"
              class="btn btn-circle btn-lg"
            >
              <i class="fab fa-youtube text-2xl"></i>
            </a>
            <a
              href="https://sqwerv.bandcamp.com/"
              target="_blank"
              rel="noopener"
              class="btn btn-circle btn-lg"
            >
              <i class="fab fa-bandcamp text-2xl"></i>
            </a>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup></script>

<style scoped>
.listen {
  min-height: calc(100vh - 80px); /* Adjust 80px to match your navbar height */
}
.spotify-iframe {
  filter: grayscale(50%) contrast(1.1);
}
</style>
